import { useDeepCompareEffect } from '../../../../../hooks/useDeepCompareEffect';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputSelectedTeams } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListTeams } from '../../components/filters-list/filters-list-teams';
import { MAX_SELECTION } from '../../initiative-performance.constants';
import { useContributingTeams } from '../../initiative-performance.hooks';

export const FiltersTeams = () => {
  const contributingTeams = useContributingTeams();
  const selectedTeams = useThroughputTabStore((state) => state.selectedTeams);

  useDeepCompareEffect(() => {
    if (contributingTeams.length > 0) {
      setThroughputSelectedTeams(contributingTeams.slice(0, MAX_SELECTION));
    }
  }, [contributingTeams]);

  return (
    <FiltersListTeams
      teams={contributingTeams}
      selectedTeams={selectedTeams}
      onSelectTeams={setThroughputSelectedTeams}
    />
  );
};
